__turbopack_context__.v({
  "bottom-section": "CoreGlobalNavigationFooter-module-scss-module__5foU-W__bottom-section",
  "container": "CoreGlobalNavigationFooter-module-scss-module__5foU-W__container",
  "copyrights": "CoreGlobalNavigationFooter-module-scss-module__5foU-W__copyrights",
  "facebook": "CoreGlobalNavigationFooter-module-scss-module__5foU-W__facebook",
  "instagram": "CoreGlobalNavigationFooter-module-scss-module__5foU-W__instagram",
  "linkedin": "CoreGlobalNavigationFooter-module-scss-module__5foU-W__linkedin",
  "logo": "CoreGlobalNavigationFooter-module-scss-module__5foU-W__logo",
  "main": "CoreGlobalNavigationFooter-module-scss-module__5foU-W__main",
  "secondary-item": "CoreGlobalNavigationFooter-module-scss-module__5foU-W__secondary-item",
  "secondary-link": "CoreGlobalNavigationFooter-module-scss-module__5foU-W__secondary-link",
  "secondary-navigation": "CoreGlobalNavigationFooter-module-scss-module__5foU-W__secondary-navigation",
  "social-link": "CoreGlobalNavigationFooter-module-scss-module__5foU-W__social-link",
  "social-links": "CoreGlobalNavigationFooter-module-scss-module__5foU-W__social-links",
  "social-media-subscribe": "CoreGlobalNavigationFooter-module-scss-module__5foU-W__social-media-subscribe",
  "subscribe-cta": "CoreGlobalNavigationFooter-module-scss-module__5foU-W__subscribe-cta",
  "subscribe-description": "CoreGlobalNavigationFooter-module-scss-module__5foU-W__subscribe-description",
  "subscribe-link": "CoreGlobalNavigationFooter-module-scss-module__5foU-W__subscribe-link",
  "tertiary-item": "CoreGlobalNavigationFooter-module-scss-module__5foU-W__tertiary-item",
  "tertiary-link": "CoreGlobalNavigationFooter-module-scss-module__5foU-W__tertiary-link",
  "tertiary-navigation": "CoreGlobalNavigationFooter-module-scss-module__5foU-W__tertiary-navigation",
  "top-section": "CoreGlobalNavigationFooter-module-scss-module__5foU-W__top-section",
  "x": "CoreGlobalNavigationFooter-module-scss-module__5foU-W__x",
  "youtube": "CoreGlobalNavigationFooter-module-scss-module__5foU-W__youtube",
});
